/** @format */

import React, { useEffect } from "react";
import { Box } from "@mui/material";

/**
 * Google AdSense Component
 * 
 * IMPORTANT: Replace "ca-pub-XXXXXXXXXX" with your actual Google AdSense Publisher ID
 * You can find this in your Google AdSense account under Account > Account information
 * 
 * @param {string} adSlot - The ad slot ID from Google AdSense
 * @param {string} adFormat - The ad format (auto, rectangle, horizontal, vertical)
 * @param {boolean} fullWidthResponsive - Whether the ad should be full width responsive
 * @param {string} style - Additional inline styles
 * @param {string} className - Additional CSS classes
 */
const GoogleAd = ({
  adSlot = "1234567890",
  adFormat = "auto",
  fullWidthResponsive = true,
  style = {},
  className = "",
}) => {
  // Get ad client ID from environment variable or use default
  const adClient = process.env.REACT_APP_GOOGLE_ADS_CLIENT_ID || "ca-pub-XXXXXXXXXX";

  useEffect(() => {
    try {
      // Push ad to Google AdSense
      if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error("Error loading Google Ad:", err);
    }
  }, []);

  return (
    <Box
      className={`google-ad-container ${className}`}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100px",
        width: "100%",
        margin: "20px 0",
        ...style,
      }}
    >
      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          ...(fullWidthResponsive && { width: "100%" }),
        }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
      />
    </Box>
  );
};

export default GoogleAd;

